import { render, staticRenderFns } from "./HeaderWithPhone.vue?vue&type=template&id=3b3b40ec"
import script from "./HeaderWithPhone.vue?vue&type=script&lang=js"
export * from "./HeaderWithPhone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports